import React from 'react';

export default ({children, url, descrizione, classe, titoloSezione}) => (
    typeof document !== `undefined` /*&& document.cookie.indexOf('cookies_consent=true') >= 0*/ ?
        <div className={`embed-custom ${classe ? classe : ''} `}>
            <h3>{titoloSezione}</h3>
            <div className="embed-responsive embed-responsive-4by3">
                <embed className="embed-responsive-item" title={titoloSezione}
                        src={url} allowFullScreen=""/>
            </div>
        </div> : <section className="container article-card-simple">
            <div className="px-custom">
                <div className="text-center py-5">
                    <h6>{(typeof window !== "undefined" && window.location.pathname.split("/")[1] === 'it')
                        ? 'La condivisione sui social e la visualizzazione di contenuti di terze parti non è disponibile per il mancato consenso all\'utilizzo di cookie di terze parti'
                        : 'Third party content display is not available for non agreement to use of third-party cookies'
                    }</h6>
                </div>
            </div>
        </section>
);


